import { persistentPropertyStorage } from '../PersistentPropertyStorage';
export default class Session {
    constructor() {
        Object.defineProperty(this, "cartToken", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
    }
    get storageKey() {
        return 'session';
    }
    load() {
        const loadedData = persistentPropertyStorage.getItem(this.storageKey);
        if (loadedData) {
            const parsedData = JSON.parse(loadedData);
            this.cartToken = parsedData.cartToken;
        }
    }
    save() {
        persistentPropertyStorage.setItem(this.storageKey, JSON.stringify(this));
    }
    setCartToken(value) {
        this.cartToken = value;
    }
}
